import React from 'react';
import { college } from '../../mock/data';

export default function FooterBrand() {
  return (
    <div className="flex items-center gap-3">
      <img src={college.logo} alt="logo" className="h-12 w-12 rounded-full bg-white object-cover ring-1 ring-white/20" />
      <div>
        <div className="text-white font-extrabold text-lg">{college.name}</div>
        <div className="text-[11px] tracking-[2px] uppercase text-blue-200/80">{college.location} · {college.since}</div>
      </div>
    </div>
  );
}
